import script from "./lecture_box.vue?vue&type=script&setup=true&lang=js"
export * from "./lecture_box.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__